import axiosClient from "../../../../../../axiosClient"

export default async (id) => {
    const result = await axiosClient.get(`/background-check-receipt-sent-list/${id}`)

    return result.data
}
